import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ContextLayout } from '../../utility/context/Layout';
import SpinnerComponent from '../@vuexy/spinner/Fallback-spinner';


const PublicRoute = ({ component: Component, fullLayout, ...rest }) => (
  <Route {...rest} render={
    (props) => {
      return (
        <ContextLayout.Consumer>
          {context => {
            let LayoutTag =
              fullLayout === true
                ? context.fullLayout
                : context.state.activeLayout === 'horizontal'
                ? context.horizontalLayout
                : context.VerticalLayout
            return (
              <LayoutTag {...props}>
                <Suspense fallback={<SpinnerComponent />}>
                  <Component {...props} />
                </Suspense>
              </LayoutTag>
            )
          }}
        </ContextLayout.Consumer>
      )
    }
  } />
);

export default PublicRoute;
